<template>
    <v-card>
        <v-card-title>
            Parc auto
            <v-spacer></v-spacer>
            <v-checkbox
                v-model="showDeleted"
                label="Include vehicule sterse"
            ></v-checkbox>
            <v-btn
                color="primary"
                dark
                class="ml-2"
                @click="addNewItem"
            >
                Adaugare
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col v-if="loading" cols="12" lg="3" class="my-2" v-for="index in new Array(8)" :key="index">
                    <v-skeleton-loader
                        class="mx-auto"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
                <v-col v-if="!loading" cols="12" lg="3" class="my-2" v-for="(vehicle, vIndex) in items" :key="vIndex">
                    <v-card class="mx-auto" @click="showPopup(vehicle)">
                        <v-img class="black--text align-end" height="200px" :src="vehicle.image">
                            <v-card-title>
                                <v-chip v-if="!_.isNil(vehicle.data.end_date)" color="error">{{ vehicle.vehicle_plate }}</v-chip>
                                <v-chip v-else :color="vehicle.issues_count ? 'warning' : 'primary'">{{ vehicle.vehicle_plate }}</v-chip>
                                <template v-if="_.isNil(vehicle.data.end_date)">
                                    <v-badge v-if="vehicle.issues_count" color="error" :content="vehicle.issues_count"></v-badge>
                                    <v-badge v-else color="success" icon="mdi-check-circle-outline"></v-badge>
                                </template>
                            </v-card-title>
                        </v-img>
                    </v-card>
                </v-col>
            </v-row>
            <v-dialog
                v-model="dialog"
                width="80%"
            >
                <v-card>
                    <v-card-title v-if="dialog && dialogData" class="headline grey lighten-2">
                        {{ dialogData.make.name }} {{ dialogData.model.name }} - {{ dialogData.vehicle_plate }}
                    </v-card-title>

                    <v-card-text v-if="dialog && dialogData">
                        <v-row>
                            <v-col cols="12" lg="4" class="my-2">
                                <v-sheet>
                                    <v-img :src="dialogData.image"/>
                                </v-sheet>
                            </v-col>

                            <v-col cols="12" lg="8" class="my-2">
                                <v-sheet>
                                    <h4>Operatii si rapoarte</h4>
                                    <br/>
                                    <span>
                                        Consum auto (consum mediu de {{ dialogData.fuel_supply_qty_avg | number}} L / 100 km / {{ workstation.data.vehicle_fuel_notification }} zile)
                                    </span>
                                    <br/>
                                    <span>
                                        Alimentari auto ({{ dialogData.fuel_supply_qty | number}} L si {{ dialogData.fuel_supply_cost | number }} RON / {{ workstation.data.vehicle_fuel_notification }} zile)
                                    </span>
                                    <br/>
                                    <span>
                                        Costuri reparatii / revizii ({{ dialogData.maintenance_cost | number }} RON / {{ workstation.data.vehicle_maintenance_notification }} zile)
                                    </span>
                                    <br/>
                                    <span>
                                        Costuri impozite/asigurari/ITP ({{ dialogData.expense_cost | number }} RON / {{ workstation.data.vehicle_expenses_notification }} zile)
                                    </span>

                                    <h4>Informatii</h4>
                                    <p v-if="Object.keys(dialogData.notices).length || parseFloat(dialogData.fuel_supply_qty_avg) > parseFloat(dialogData.data.avg_consumption)">
                                        <template v-for="notice in Object.values(dialogData.notices)">
                                            <template v-if="notice.maintenance_type === 'MAINTENANCE'">
                                                "{{ notice.maintenance_name }}" necesita interventie
                                                <template v-if="!_.isNil(notice.date_expire) && !_.isNil(notice.km_expire)">la {{ notice.notification_km }} si/sau in data de {{ new Date(notice.valability_end) | date }}</template>
                                                <template v-else-if="!_.isNil(notice.date_expire)">in data de {{ new Date(notice.valability_end) | date }}</template>
                                                <template v-else-if="!_.isNil(notice.km_expire)">la {{ notice.notification_km }}.</template>
                                                .<br/>
                                            </template>
                                            <template v-else>
                                                {{ notice.maintenance_name }} {{ !_.isNil(notice.date_expire) ? `a expirat de ${Math.abs(notice.date_expire)} zile` : `expira in ${Math.abs(notice.date_expire)} zile` }}.<br/>
                                            </template>
                                        </template>
                                        <template v-if="parseFloat(dialogData.fuel_supply_qty_avg) > parseFloat(dialogData.data.avg_consumption)">
                                            Consumul mediu inregistrat este {{ dialogData.fuel_supply_qty_avg | number }} L / 100 KM comparativ cu consumul original de {{ dialogData.data.avg_consumption | number }} L / 100 KM.
                                        </template>
                                    </p>
                                    <p v-else>Nu sunt informatii</p>
                                </v-sheet>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-btn
                            color="default"
                            text
                            @click="dialog = false"
                        >
                            Inchidere
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="$router.push({ name: 'vehicles-edit', params: { id: dialogData.id }})"
                        >
                            Actualizare
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-text>
    </v-card>
</template>
<script>
    import {createNamespacedHelpers} from "vuex";
    const { mapState } = createNamespacedHelpers("workstation");
    export default {
        data: () => ({
            showDeleted: false,
            loading: true,
            items: [],
            dialog: false,
            dialogData: {},
            meta: {
                pagination: {
                    count: 0,
                    current_page: 0,
                    per_page: 0,
                    total: 0,
                    total_pages: 0
                }
            }
        }),

        computed: {
            ...mapState({
                workstation: "workstation"
            })
        },

        async created () {
            await this.initialize()
        },

        watch: {
            showDeleted: {
                handler() {
                    this.initialize()
                }
            }
        },

        methods: {
            async initialize () {
                this.loading = true;
                var query = this.$db.Vehicle
                    .include(
                        'make',
                        'model'
                    )
                    .append(
                        'image',
                        'notices',
                        'issues_count',
                        'fuel_supply_qty',
                        'maintenance_cost',
                        'expense_cost',
                        'fuel_supply_qty_avg',
                        'fuel_supply_cost'
                    )
                    .page(1)
                    .limit(50)

                if(this.showDeleted) query = query.where("withTrashed", "1")

                let { data, meta } = await query.get()
                this.items = data
                this.loading = false
            },

            editItem (item) {
                this.$router.push({ name: 'vehicles-edit', params: { id: item.id } })
            },

            showPopup(item) {
                this.dialog = true;
                this.dialogData = item
            },

            addNewItem: function() {
                this.$router.push({ name: 'vehicles-create' })
            },
        },
    };
</script>
